import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
declare var $: any;
import { lastValueFrom } from 'rxjs';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { WsBrandService } from 'src/app/ws/wsBrand/ws-brand.service';
import { MGetSkinConcernResponse, MGetSkinTypeResponse } from './individual-brand.module';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MGetBrandByInitialsRequest, MGetBrandResponse, MGetProductRequest, MGetProductResponse } from '../product/product.module';


@Component({
  selector: 'app-individual-brand',
  templateUrl: './individual-brand.component.html',
  styleUrls: ['./individual-brand.component.scss']
})
export class IndividualBrandComponent {
  brandName: any;
  mGetBrandByInitialsRequest: MGetBrandByInitialsRequest = new MGetBrandByInitialsRequest();
  mGetBrandResponse: MGetBrandResponse = new MGetBrandResponse()
  mGetProductRequest: MGetProductRequest = new MGetProductRequest()
  mGetProductResponse: MGetProductResponse = new MGetProductResponse()
  skinConcernArray: any = [];
  skinTypeArray: any = [];
  skinConcernId: any;
  skinTypeId: any;
  brandId: any;
  selectedGender: any
  mGetSkinConcernResponse: MGetSkinConcernResponse = new MGetSkinConcernResponse()
  mGetSkinTypeResponse: MGetSkinTypeResponse = new MGetSkinTypeResponse()
  sortBy: boolean = false;
  relevence: boolean = false;
  priceHighToLow: boolean = false;
  productCount: number = 0;
  brandProductList: any = [];
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mWishlistData: any = [];
  type: any;
  constructor(private modalService: NgbModal, private wsBrandService: WsBrandService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private wsShopAllService: WsShopallService,
    private _commonBehaviorChangeService: CommonBehaviorChangeService) {
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
      this.brandProductList && this.brandProductList.length > 0 && this.brandProductList.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        }
      })
    })
    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.activatedRoute.queryParams.subscribe(async (data) => {
          if (this.router.getCurrentNavigation()?.extras?.state) {
            const state: any = this.router.getCurrentNavigation()?.extras.state;
            this.brandName = state.state.name;
            this.mGetBrandByInitialsRequest.name = this.brandName;
          }
        })
      }
    });
  }

  ngOnInit() {
    this.brandName = this.router.url.split('/')[2]
    this.mGetBrandByInitialsRequest.name = this.brandName;
    this.getAllBrandByInitials()
    this.getSkinConcernList()
    this.getSkinTypeList()
  }

  /**
  * Date: 11-06-23
  * Method : This method is used to get brand by its name and initials
  */
  async getAllBrandByInitials() {
    const getAllBrand = this.wsShopAllService.getBrandByInitials(this.mGetBrandByInitialsRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data;
        if (this.mGetBrandResponse.data.length > 0) {
          this.brandId = this.mGetBrandResponse.data[0].id
          this.getAllProductByParameters()
        }
      } else {
      }
    })
  }

  /**
   * Date: 11-06-23
   * Method: This method is used to get all product by parameter passed
   */
  async getAllProductByParameters() {
    this.mGetProductRequest.brand = "" + this.brandId;
    if (this.skinConcernId) {
      this.mGetProductRequest.skin_concerns = "" + this.skinConcernId;
    } else {
      this.mGetProductRequest.skin_concerns = ""
    }
    if (this.skinTypeId) {
      this.mGetProductRequest.skin_type = "" + this.skinTypeId;
    } else {
      this.skinTypeId = ""
    }
    if (this.relevence) {
      this.mGetProductRequest.relevence = this.relevence;
    }
    if (this.priceHighToLow) {
      this.mGetProductRequest.priceHighToLow = this.priceHighToLow;
    }
    if (this.selectedGender == 0) {
      this.mGetProductRequest.gender = 0
    } else {
      this.mGetProductRequest.gender = this.selectedGender
    }
    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(this.mGetProductRequest)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      if (this.mGetProductResponse.data && this.mGetProductResponse.data.length < 1) {
        this.mGetProductResponse = response;
        this.brandProductList = response.data;
        if (this.mGetBrandResponse.data && this.mGetProductResponse.data.length > 0) {
          this.insertAt(this.brandProductList, 2, this.brandProductList[0])
        }
        this.brandProductList.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          }
        })
        this.brandProductList.forEach((product: any) => {
          if (this.mWishlistData.length > 0) {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          }
        })
      } else {
        response.data.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product.cartQty = cartPresent[0].qty;
          }
        })
        response.data.forEach((product: any) => {
          if (this.mWishlistData.length > 0) {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          }
        })
        this.mGetProductResponse = response;
        this.brandProductList = [... this.brandProductList, ...response.data];
      }
      this.productCount = this.brandProductList.length;
    })
  }

  insertAt(array: any, index: any, ...elementsArray: any) {
    array.splice(index, 0, ...elementsArray);
  }


  /**
   * Date: 11-06-23
   * Method: This method is used ot filter products by skin concern
   * @param val : This param is a ids of skin concern
   */
  selectSkinConcern(val: any, web?: boolean) {
    var index = this.skinConcernArray.findIndex((skinConcern: any) => skinConcern == val)
    if (index > -1) {
      this.skinConcernArray.splice(index, 1)
    } else {
      this.skinConcernArray.push(val)
    }
    this.skinConcernId = this.skinConcernArray.join(',');
    if (web) {
      this.appyFilter()
    }
  }

  /**
   * Date: 11-06-23
   * Method: This method is used ot filter products by skin type
   * @param val : This param is a ids of skin type
   */

  selectSkinType(val: any, web?: boolean) {
    var index = this.skinTypeArray.findIndex((skinType: any) => skinType == val)
    if (index > -1) {
      this.skinTypeArray.splice(index, 1)
    } else {
      this.skinTypeArray.push(val)
    }
    this.skinTypeId = this.skinTypeArray.join(',');
    if (web) {
      this.appyFilter()
    }
  }

  appyFilter() {
    this.mGetProductRequest.brand = "" + this.brandId;
    this.mGetProductResponse.data.splice(0, this.mGetProductResponse.data.length)
    this.brandProductList.splice(0, this.brandProductList.length)
    this.getAllProductByParameters()
  }

  clearFilter() {
    this.brandId = ''
    this.skinTypeArray = [];
    this.skinTypeId = '';
    this.skinConcernArray = [];
    this.skinConcernId = '';
    this.mGetProductRequest.skip = 0
    this.getAllProductByParameters();
  }

  /**
   * Date: 11-06-23
   * Method: This method is used to filter products by gender
   * @param val : This param is a ids of gender
   */
  selectGender(val: any) {
    if (this.selectedGender == val) {
      $('#gender_' + val).removeClass('active_bold')
      this.selectedGender = 0
    } else {
      $('.gender').removeClass('active_bold')
      $('#gender_' + val).addClass('active_bold')
      this.selectedGender = val
    }

    this.mGetProductRequest.brand = "" + this.brandId;
    this.mGetProductResponse.data.splice(0, this.mGetProductResponse.data.length)
    this.brandProductList.splice(0, this.brandProductList.length)
    this.getAllProductByParameters()
  }

  async getSkinConcernList() {
    const warehouseList = this.wsBrandService.getSkinConcernList()
    await lastValueFrom(warehouseList).then(response => {
      if (response && response.statusCode == 200) {
        this.mGetSkinConcernResponse.data = response.data;
      } else {
      }
    })
  }

  async getSkinTypeList() {
    const warehouseList = this.wsBrandService.getSkinTypeList()
    await lastValueFrom(warehouseList).then(response => {
      if (response && response.statusCode == 200) {
        this.mGetSkinTypeResponse.data = response.data;
      } else {
      }
    })
  }


  /**
   * Date: 11-06-23
   * Method: This method is used to open and close the sortby toggle
   */
  setSortBy() {
    this.sortBy = !this.sortBy
  }

  /**
   * Date: 11-06-23
   * Method : This method is used to filter product by relevance
   */
  selectRelevance() {
    this.relevence = !this.relevence;
    this.mGetProductRequest.brand = "" + this.brandId;
    this.getAllProductByParameters()
  }

  /**
   * Date: 11-06-23
   * Method : This method is used to filter product by price high to low and low to high
   * @param val : This param is the value true/false 
   */
  selectPriceSort(val: any) {
    this.priceHighToLow = val
    this.mGetProductRequest.brand = "" + this.brandId;
    this.getAllProductByParameters()
  }

  onScrollProduct() {
    if (this.productCount < this.mGetProductResponse.totalRecords) {
      this.mGetProductRequest.skip = this.productCount;
      this.mGetProductRequest.brand = "" + this.brandId;
      this.getAllProductByParameters();
    }

  }

  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  async addToCartCommon(product: any, index?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    if (this.type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    if (this.type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mAddUpdateCartModule = new MAddUpdateCartModule();
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
      if (product.like) {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
      this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this.mGetProductResponse.data[index].like = product.like ? false : true;
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  async addtoCart(product: any, val: any, index?: any, productType?: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product, index)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product, index)
        }
      })
    }
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  async addCartItem(product: any, index: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.brandProductList[index]['cartQty'] = this.brandProductList[index]['cartQty'] + 1
    this.mAddUpdateCartModule.qty = this.brandProductList[index]['cartQty']
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  async removeCartItem(product: any, index: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    }
    if (product.cartQty > 0) {
      this.brandProductList[index]['cartQty'] = this.brandProductList[index]['cartQty'] - 1
      this.mAddUpdateCartModule.qty = this.brandProductList[index]['cartQty']
    } else {
      this.mAddUpdateCartModule.qty = 0;
      delete this.brandProductList[index]['cartQty']
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

}
